/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-01-04 14:05:30
 *
 *******************************************************/
// @flow

import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import { TextStyle } from '@shopify/polaris';

const MetricsTable = props => {
  const { i18n } = props;

  const metrics = [
    { name: 'conversion', weight: 'high' },
    { name: 'add-to-cart', weight: 'medium' },
    { name: 'click-through', weight: 'low' }
  ];
  return (
    <div className="metric">
      <TextStyle variation="strong">
        {i18n.translate('AdminHTML.ProductPerformanceRanking.Metrics.title')}
      </TextStyle>
      <div className="content">
        {i18n.translate('AdminHTML.ProductPerformanceRanking.Metrics.content')}
      </div>
      <div
        className="Polaris-DataTable BC-DataTable__MetricsRanking"
        style={{
          borderBottom: '0.0625rem solid var(--p-divider)'
        }}>
        <div className="Polaris-DataTable__ScrollContainer" style={{ marginLeft: 0 }}>
          <table className="Polaris-DataTable__Table">
            <thead>
              <tr>
                <td className={`Polaris-DataTable__Cell Polaris-DataTable__Cell--header`}>
                  {i18n.translate('AdminHTML.ProductPerformanceRanking.Metrics.metric_Heading')}
                </td>
                <td className={`Polaris-DataTable__Cell  Polaris-DataTable__Cell--header`}>
                  {i18n.translate('AdminHTML.ProductPerformanceRanking.Metrics.weight_Heading')}
                </td>
              </tr>
            </thead>
            <tbody>
              {metrics.map((metric, index) => (
                <tr className="Polaris-DataTable__TableRow" key={metric.name + index}>
                  <td className="Polaris-DataTable__Cell">
                    <TextStyle variation="strong">
                      {i18n.translate(
                        `AdminHTML.ProductPerformanceRanking.Metrics.metric0${index + 1}_Label`
                      )}
                    </TextStyle>
                    <div style={{ color: '#6D7175' }}>
                      {i18n.translate(
                        `AdminHTML.ProductPerformanceRanking.Metrics.metric0${index + 1}_Content`
                      )}
                    </div>
                  </td>
                  <td className="Polaris-DataTable__Cell Polaris-DataTable__Cell--weight">
                    <div>
                      <div className={`weight-dot weight-dot-${metric.weight}`} />
                      <div>
                        {i18n.translate(
                          `AdminHTML.ProductPerformanceRanking.Metrics.${metric.weight}`
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default withI18n()(MetricsTable);
